import React from "react";

import { PER_PAGE_OPTIONS } from "../data/peseeData";

const PeseePager = ({
  page,
  perPage,
  total,
  totalPages,
  onPageChange,
  onPerPageChange,
}) => {
  return (
    <div className="mt-4 flex flex-col gap-3 border-t border-slate-100 pt-4 dark:border-white/10 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-sm text-slate-600 dark:text-slate-300">
        Page{" "}
        <span className="font-bold text-slate-950 dark:text-white">{page}</span>{" "}
        / {totalPages} — {total} ligne{total > 1 ? "s" : ""}
      </p>

      <div className="flex items-center gap-2">
        <select
          value={perPage}
          onChange={(event) => onPerPageChange(Number(event.target.value))}
          className="h-10 rounded-xl border border-slate-200 bg-white px-2 text-sm font-semibold text-slate-800 dark:border-white/10 dark:bg-slate-900 dark:text-white"
        >
          {PER_PAGE_OPTIONS.map((option) => (
            <option key={option} value={option}>
              {option}/page
            </option>
          ))}
        </select>

        <div className="inline-flex overflow-hidden rounded-xl border border-slate-200 dark:border-white/10">
          <button
            type="button"
            onClick={() => onPageChange(Math.max(1, page - 1))}
            className="h-10 px-4 text-sm font-bold transition hover:bg-slate-100 disabled:opacity-40 dark:hover:bg-white/10"
            disabled={page <= 1}
          >
            ←
          </button>

          <button
            type="button"
            onClick={() => onPageChange(Math.min(totalPages, page + 1))}
            className="h-10 px-4 text-sm font-bold transition hover:bg-slate-100 disabled:opacity-40 dark:hover:bg-white/10"
            disabled={page >= totalPages}
          >
            →
          </button>
        </div>
      </div>
    </div>
  );
};

export default PeseePager;